import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const Container = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
`;
